export default __webpack_public_path__ + "img/pin_icons/industrial_b.png";